import { Component, OnInit } from '@angular/core';
import { CoursesService } from 'src/app/services/courses.service';
import { Page } from 'src/app/classes/Page';
import { ConfirmDialogComponent } from 'src/app/components/dialog/confirm-dialog/confirm-dialog.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {
  AddEditCourseModalComponent
} from 'src/app/components/lessons-schedule/lessons-schedule-list/courses-list/add-edit-course-modal/add-edit-course-modal.component';
import { FormGroup } from '@angular/forms';
import { Course } from 'src/app/classes/Course';
import { omit } from 'src/app/helpers';

@Component({
  selector: 'app-courses-list',
  templateUrl: './courses-list.component.html',
  styleUrls: ['./courses-list.component.scss']
})
export class CoursesListComponent implements OnInit {
  public courses = [];
  public loading = false;
  public errorMessage: string;
  public pageNumber = 1;
  public totalElements = 0;
  public pageSizes = [10, 20, 50];
  public pageSize = this.pageSizes[0];
  private currentDialog = null;

  constructor(
    private coursesService: CoursesService,
    private modalService: NgbModal,
  ) {
  }

  ngOnInit(): void {
    this.refreshCoursesList();
  }

  handlePageChange(event): void {
    this.pageNumber = event;
    this.refreshCoursesList();
  }

  handlePageSizeChange(event): void {
    this.pageSize = event.target.value;
    this.pageNumber = 1;
    this.refreshCoursesList();
  }

  getMinLimit(): number {
    return this.pageSize * (this.pageNumber - 1) + 1;
  }

  getMaxLimit(): number {
    const maxLimit = this.pageSize * this.pageNumber;
    return maxLimit <= this.totalElements ? maxLimit : this.totalElements;
  }

  refreshCoursesList(): void {
    this.loading = true;
    this.coursesService.getAll(this.pageNumber - 1, this.pageSize).subscribe({
      next: (response: Page<any>) => {
        this.courses = response.content;
        this.totalElements = response.totalElements;
      },
      error: (error) => {
        this.errorMessage = error.error.error;
      },
      complete: () => (this.loading = false),
    });
  }

  openEditModal(course: Course): void {
    this.currentDialog = this.modalService.open(AddEditCourseModalComponent, {
      scrollable: true,
      windowClass: 'modal-user-edit',
      size: 'lg',
      centered: true,
    });

    this.currentDialog.componentInstance.course = course;

    this.currentDialog.result.then(
      (result) => {
        if (result instanceof FormGroup) {
          const schedulesIds = [...result.value.selectedSchedules.map(s => s.id)];
          const editedCourse = omit(new Course(result.value), ['selectedSchedules']);
          editedCourse.schedulesIds = [ ...schedulesIds ];
          if (!course?.id) {
            delete editedCourse.schedulesIds;
          }
          this.coursesService.addOrEdit(editedCourse, course?.id).subscribe({
            next: (c) => {
              if (!course?.id) {
                this.coursesService.addOrEdit({ ...editedCourse, schedulesIds }, c.id).subscribe({
                  next: () => {
                    this.refreshCoursesList();
                  },
                  error: (error) => (this.errorMessage = error.error.error),
                });
              } else {
                this.refreshCoursesList();
              }
            },
            error: (error) => (this.errorMessage = error.error.error),
          });
        }
      },
      (error) => {
        console.log('Dialog close error: ' + error);
      }
    );
  }

  openDeleteConfirmModal(course: any): void {
    this.currentDialog = this.modalService.open(ConfirmDialogComponent, {
      scrollable: true,
      windowClass: 'modal-confirm',
      size: 'md',
      centered: true,
    });

    this.currentDialog.componentInstance.message = `Are you sure that you want to delete course ${course.name}`;

    this.currentDialog.result.then(
      (result) => {
        if (result.status === 'confirmed') {
          this.coursesService.delete(course.id).subscribe({
            next: () => this.refreshCoursesList(),
            error: (error) => (this.errorMessage = error.error.error),
          });
        }
      },
      (error) => {
        console.log('Dialog close error: ' + error);
      }
    );
  }
}
